import React from 'react'

import PropTypes from 'prop-types'

import IconBase, { Path } from '../IconBase/IconBase'
function Trash({ color = 'icon.primary', ...props }) {
  return (
    <IconBase viewBox='0 0 16 19' {...props}>
      <Path
        d='M14 4H15'
        stroke={color}
        fill='transparent'
        strokeWidth='1.5'
        strokedLinecap='round'
        strokedLinejoin='round'
      />
      <Path
        d='M5 7.94531V14.0053'
        stroke={color}
        fill='transparent'
        strokeWidth='1.5'
        strokedLinecap='round'
        strokedLinejoin='round'
      />
      <Path
        d='M8 6.78125V15.0513'
        stroke={color}
        fill='transparent'
        strokeWidth='1.5'
        strokedLinecap='round'
        strokedLinejoin='round'
      />
      <Path
        d='M11 7.94531V14.0053'
        stroke={color}
        fill='transparent'
        strokeWidth='1.5'
        strokedLinecap='round'
        strokedLinejoin='round'
      />
      <Path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M11.795 17.944H4.205C2.987 17.944 2 16.957 2 15.739V4H14V15.739C14 16.957 13.013
                     17.944 11.795 17.944Z'
        stroke={color}
        fill='transparent'
        strokeWidth='1.5'
        strokedLinecap='round'
        strokedLinejoin='round'
      />
      <Path
        d='M12 4L11.262 1.695C11.129 1.281 10.744 1 10.31 1H5.69C5.255 1 4.87 1.281 4.738 1.695L4 4'
        stroke={color}
        fill='transparent'
        strokeWidth='1.5'
        strokedLinecap='round'
        strokedLinejoin='round'
      />
      <Path
        d='M1 4H2'
        stroke={color}
        fill='transparent'
        strokeWidth='1.5'
        strokedLinecap='round'
        strokedLinejoin='round'
      />
    </IconBase>
  )
}
Trash.propTypes = {
  color: PropTypes.string,
}

export default Trash
